// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-2a615310] .el-input-number .el-input__inner {\n  text-align: left;\n}", ""]);
// Exports
module.exports = exports;
